<script setup lang="ts">
definePageMeta({ layout: 'default' })

useHead({
  title: 'Open Source & Docs',
  meta: [
    {
      name: 'description',
      content: 'Quellcode und einige Dokumentation zum Projekt Bahn-Vorhersage.'
    }
  ]
})
</script>

<template>
  <div id="open-source" class="row g-2 justify-content-center my-5">
    <div class="col-xxl-6 col-xl-7 col-lg-8 col-md-11 hyphenate">
      <h1><i class="icon icon-gitlab"></i> Open Source</h1>
      <p>Dieses Projekt ist Open Source. Der gesamte Quellcode ist auf GitLab zu finden.</p>
      <a
        class="btn btn-primary w-100 mb-3"
        href="https://gitlab.com/bahnvorhersage/bahnvorhersage"
        target="_blank"
        rel="noopener noreferrer"
        ><i class="icon icon-gitlab"></i> Backend / Main Repo</a
      >
      <a
        class="btn btn-primary w-100 mb-3"
        href="https://gitlab.com/bahnvorhersage/bahnvorhersage_frontend"
        target="_blank"
        rel="noopener noreferrer"
        ><i class="icon icon-gitlab"></i> Frontend</a
      >
      <h2>Docs</h2>
      <h3>38c3</h3>
      <p>
        Beim 38. Chaos Communication Congress hat Theo einen Vortrag über das Projekt gehalten.
        Darin sind die aktuellsten Infos zusammengefasst.
      </p>
      <div class="video-container">
        <iframe
          class="video"
          src="https://media.ccc.de/v/38c3-wann-klappt-der-anschluss-wann-nicht-und-wie-sagt-man-chaos-vorher/oembed"
          frameborder="0"
          allowfullscreen
        ></iframe>
      </div>
      <a
        class="btn btn-primary w-100 my-3"
        href="https://media.ccc.de/v/38c3-wann-klappt-der-anschluss-wann-nicht-und-wie-sagt-man-chaos-vorher"
        target="_blank"
        rel="noopener noreferrer"
        >Video des Vortrags</a
      >
      <a
        class="btn btn-primary w-100 mb-3"
        href="https://gitlab.com/bahnvorhersage/docs/-/blob/7bebb6e0f5e40fd15a788b7d53330707e6c697f8/pr%C3%A4si_38c3.pdf"
        target="_blank"
        rel="noopener noreferrer"
        >Vortragsfolien</a
      >
      <p>
        Der Vortrag wirkt so als wäre es ein Einzelprojekt, jedoch war es besonders Marius, der das
        Projekt gemeinsam mit Theo gestartet hat, die Projektidee hatte und in den ersten paar
        Jahren sehr aktiv daran mitgearbeitet hat.
      </p>
      <h3>Jugend Forscht</h3>
      <p>
        Mit diesem Projekt haben wir drei mal bei Jugend Forscht teilgenommen. Die schriftlichen
        Ausarbeitungen für Jugend Forscht beinhalten viele Details zu dem Projekt. Ein Großteil der
        Infos darin ist jedoch veraltet.
      </p>
      <a
        class="btn btn-primary w-100 mb-3"
        href="https://gitlab.com/bahnvorhersage/docs/-/blob/main/Langfassung_Bahnvorhersage_2023.pdf"
        target="_blank"
        rel="noopener noreferrer"
        ><i class="icon icon-gitlab"></i> Langfassung 2023</a
      >
      <a
        class="btn btn-primary w-100 mb-3"
        href="https://gitlab.com/bahnvorhersage/docs/-/blob/main/Old%20Docs/JuFo%202021.pdf"
        target="_blank"
        rel="noopener noreferrer"
        ><i class="icon icon-gitlab"></i> Langfassung 2021</a
      >
      <a
        class="btn btn-primary w-100 mb-3"
        href="https://gitlab.com/bahnvorhersage/docs/-/blob/main/Old%20Docs/JuFo%202020.pdf"
        target="_blank"
        rel="noopener noreferrer"
        ><i class="icon icon-gitlab"></i> Langfassung 2020</a
      >
    </div>
  </div>
</template>

<style scoped lang="scss">
.video-container {
  position: relative;
  overflow: hidden;
  width: 100%;
  padding-top: 56.25%;
}

.video {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
}
</style>
